const o = {
  code: "lo",
  facebook: "lo_LA",
  label: "ພາສາລາວ",
  loadingText: "ກຳ ລັງໂຫລດ ...",
  translations: {
    ar: "ພາສາອາຣາບິກ",
    de: "ພາສາເຢຍລະມັນ",
    en: "ພາສາອັງກິດ",
    es: "ພາສາແອັສປາຍ",
    fr: "ພາສາຝຣັ່ງ",
    he: "ພາສາຮີບຣິວ",
    hi: "ພາສາຮິນດູ",
    id: "ພາສາອິນໂດນີເຊຍ",
    it: "ພາສາອີຕາລີ",
    ja: "ພາສາຍີ່ປຸ່ນ",
    km: "ພາສາຂະເໝນ",
    ko: "ພາສາເກົາຫຼີ",
    lo: "ພາສາລາວ",
    ms: "ພາສາມາເລເຊຍ",
    nl: "ພາສາໂດັດ",
    pt: "ພາສາປັອກຕຸຍການ",
    ru: "ພາສາລັດເຊຍ",
    th: "ພາສາໄທ",
    tl: "ພາສາຟິລິບປິນ",
    tr: "ພາສາຕວກກີ",
    vi: "ພາສາຫວຽດນາມ",
    "zh-CN": "ພາສາຈີນ (ກາງ)",
    "zh-TW": "ພາສາຈີນ (ດັ້ງເດີມ)"
  }
};
export {
  o as lao
};
